import { normalizeLocale } from './constants.helpers';
import { isOnOrAfterToday } from './date.helper';

/**
 * Converts a selected locale to the canonical locale used by i18next.
 */
export const updateLanguageCode = (selectedLanguageCode) =>
  normalizeLocale(selectedLanguageCode);

/**
 * Sets the closest supported language based on browser preferences.
 *
 * @param {object} i18n i18next instance
 */
export const setLanguageCode = (i18n) => {
  const storedLanguage = localStorage.getItem('i18nextLng');

  // A manually selected language must survive page reloads.
  if (storedLanguage) {
    const languageCode = normalizeLocale(storedLanguage);

    // Migrates stale values such as pt-br, zh-hans, zh-tw, etc.
    localStorage.setItem('i18nextLng', languageCode);

    return i18n.changeLanguage(languageCode);
  }

  // Use the browser language only when there is no saved user preference.
  const browserLanguage =
    window.navigator.languages?.[0] || window.navigator.language || 'en';

  const languageCode = normalizeLocale(browserLanguage);

  localStorage.setItem('i18nextLng', languageCode);

  return i18n.changeLanguage(languageCode);
};

/**
 * Returns the warranty flag.
 *
 * @param {string | Date} warrantyEndDate
 * @returns {boolean}
 */
export const isUnderWarranty = (warrantyEndDate) =>
  isOnOrAfterToday(warrantyEndDate);

/**
 * Returns whether the currently selected locale is right-to-left.
 *
 * @returns {boolean}
 */
export const isRightToLeft = () => {
  const storedLanguage = localStorage.getItem('i18nextLng') || 'en';
  const canonicalLanguage = normalizeLocale(storedLanguage);
  const baseLanguage = canonicalLanguage.split('-')[0].toLowerCase();

  return /^(ar|he|fa)$/.test(baseLanguage);
};

/**
 * Returns translated model-name entries.
 *
 * @param {Array} businessData
 * @returns {Array | undefined}
 */
export const findModelName = (businessData) => {
  const translations = businessData?.[0]?.TranslationsForEnglish;

  return translations?.filter(
    (item) =>
      (item.Type === 'MODEL_NAME' && item.Translation) ||
      (item.Type === 'PORTAL_CATALOG_LINE' && item.Translation),
  );
};
